import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth/AppAuthContext";

export function VerifyLoggedIn() {
    const { userLoggedIn, account } = useAuth();
    if (!userLoggedIn) {
        return (<Navigate to={'/login'} replace={true} />);
    }
    return (
        <>
            {!userLoggedIn && (<Navigate to={'/login'} replace={true} />)}
            {!account.FirstName && (<Navigate to={'/setup-account'} replace={true} />)}
        </>
    );
}